export default "__VITE_ASSET__xXcfyqiA__"